
export { getGa4Items } from "./src/gtm"
export { gtmSendEvent } from "./src/gtm"